import { FavoriteParams } from 'shared/api/avia/favorites'

export const getCountOfPassengers = (
  passengers?: FavoriteParams | null,
): number => {
  if (!passengers) return 0

  return (
    (passengers?.adults || 0) +
    (passengers?.children || 0) +
    (passengers?.infants || 0) +
    (passengers?.infants_with_place || 0)
  )
}
